import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "absolute top-0 z-50 bg-neutral-200 dark:bg-neutral-900 w-full h-full" }
const _hoisted_2 = { class: "flex flex-wrap w-full h-full items-center justify-center text-center text-neutral-400" }
const _hoisted_3 = { class: "flex mb-20 items-center space-x-1" }

import { computed } from 'vue'
    import Icon from '@/components/Icon/IndexIcon.vue'

    import useToggleTheme from '@/hooks/useToggleTheme'
    
export default /*#__PURE__*/_defineComponent({
  __name: 'PreviewLoading',
  setup(__props) {

    const { themeDark } = useToggleTheme()
    const IconColor = computed(() => themeDark() ? 'white' : 'black')


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, {
      "leave-active-class": "transition duration-100 ease-in",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", null, [
                _createVNode(Icon, {
                  size: "40",
                  name: "Loading",
                  color: _unref(IconColor)
                }, null, 8, ["color"])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})